// Mirrors backend _format_message: safe markdown subset -> HTML (for live preview).
export function formatMessage(text) {
  let s = (text || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" style="color:#1E3A78;">$1</a>');
  s = s.replace(/\*\*([^*]+)\*\*/g, "<b>$1</b>");
  const lines = s.split("\n").map((line) => {
    if (line.startsWith("## ")) return `<h2 style="font-family:Georgia,serif;font-size:20px;margin:16px 0 8px;color:#101B3D;">${line.slice(3)}</h2>`;
    if (line.startsWith("# ")) return `<h1 style="font-family:Georgia,serif;font-size:24px;margin:18px 0 10px;color:#101B3D;">${line.slice(2)}</h1>`;
    return line;
  });
  return lines.join("<br/>");
}
